import Card from "../Card";
import Ruppee from "../../assets/Icons/RuppeeIcon.svg"
export default function PersonalLoanCard() {
  return (
    <Card >
      <div className="flex flex-col gap-[12px] md:gap-[16px] lg:gap-[24px]">
        <div className="block md:hidden">
          <img
            src={Ruppee}
            className=""
          />
        </div>
        <p className="font-filson-soft font-[700] text-[16px] md:text-[20px] lg:text-[24px] text-[#424952] leading-[20px] md:leading-[28px] lg:leading-[32px] tracking-[-2%]">Personal Loan</p>
        <p className="font-Apparat font-[500] text-[16px] md:text-[18px] text-[#424952B2] leading-[19.2px] md:leading-[24px] tracking-[-2%]">
          Congratulations! Your credit score qualifies you to apply for a loan up to.
        </p>
        <p className="font-filson-soft font-[700] text-[24px] md:text-[28px] lg:text-[32px] text-[#262626] leading-[24px] md:leading-[32px] lg:leading-[37.12px] tracking-[-2%]">Rs2,00,000</p>
      </div>

      <p className="font-Apparat font-[700] text-[16px] md:text-[18px]  leading-[19.2px] md:leading-[24px] tracking-[-2%] text-[#424952B2] my-[12px] md:my-[58px]">At the interest rate of <span
        className="font-Apparat font-[700] text-[16px] md:text-[18px] text-[#262626] leading-[19.2px] md:leading-[24px] tracking-[-2%] "
      >18%</span></p>
      <p className="font-Apparat font-[700] text-[16px] md:text-[20px] lg:text-[24px] text-[#424952] leading-[20px] md:leading-[32px] tracking-[-2%] mt-[16px] md:mt-[0px] mb-[18px]">Customize your Loan Amount</p>
      <input
        type="range"
        // min={min}
        // max={max}
        // value={value}
        // onChange={handleChange}
        className="slider"
      />
      <div className="flex justify-between mt-[8px]">
        <span className="font-filson-soft font-[700] text-[16px] md:text-[20px] lg:text-[24px] text-[#424952] leading-[19px] md:leading-[32px] tracking-[-2%] mb-[12px]">0</span>
        <span className="font-filson-soft font-[700] text-[16px] md:text-[20px] lg:text-[24px] text-[#424952] leading-[19px] md:leading-[32px] tracking-[-2%] mb-[12px]">2 Lac</span>
      </div>
      {/* <button>Apply Now</button> */}
    </Card>
  )
}